import { render } from "./AvailableOrders.vue?vue&type=template&id=c29bab70"
import script from "./AvailableOrders.vue?vue&type=script&lang=js"
export * from "./AvailableOrders.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tom/tom/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__